import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './JobSuccess.css';

const JobSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const whatsappURL = location.state?.whatsappURL;

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className="job-success-container">
      <h2>✅ Job Submitted Successfully</h2>
      <p>Thank you for submitting the job. You can now send it via WhatsApp:</p>

      {whatsappURL ? (
        <a
          href={whatsappURL}
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-button"
        >
          📤 Send on WhatsApp
        </a>
      ) : (
        <p style={{ color: '#888' }}>WhatsApp URL not available.</p>
      )}

      
      <button onClick={() => navigate('/')} style={{ background: 'red', color: 'white', marginTop: '20px' }}>
  Go to Homepage
</button>

    </div>
  );
};

export default JobSuccess;
